export const ADD_DOCUMENT_TYPE = "ADD_DOCUMENT_TYPE";
export const REQUEST_SERVICES = "REQUEST_SERVICES";
export const REQUEST_FIELD_TYPES = "REQUEST_FIELD_TYPES";
export const SET_FIELD_TYPES = "SET_FIELD_TYPES";
export const SET_SERVICES = "SET_SERVICES";